/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CheckedRadioGroup } from "../../../../shared/components/commonComponents/CheckedRadioGroup";
import { setOperatorsSettlementCycleAction } from "../../../../redux/action-creators/operatorSettlementConfig";
import { Button } from "../../../../shared/widgets";
import "./operatorConfig.css";

function OperatorConfigModal(props) {
  const dispatch = useDispatch();

  const {
    selected, selectedCity, setSelected, availableConfigs, rowData = {},
  } = props;
  const [settlementConfigData, setSettlementConfigData] = useState({
    settlementCycle: "",
  });

  const onChangeHandler = ({ target: { name, value } }) => {
    setSettlementConfigData({ ...settlementConfigData, [name]: value });
  };

  const handleSave = useCallback(() => {
    dispatch(setOperatorsSettlementCycleAction({
      cityId: rowData?.cityId ? Number(rowData?.cityId) : Number(selectedCity?.cityId),
      operatorIdArr: rowData?.operatorId
        ? [Number(rowData?.operatorId)]
        : selected.map((item) => Number(item)),
      cycleType: settlementConfigData.settlementCycle,
    }));

    setSelected([]);
  }, [dispatch, rowData?.cityId,
    rowData?.operatorId, settlementConfigData.settlementCycle]);

  useEffect(() => {
    onChangeHandler({ target: { name: "settlementCycle", value: rowData?.cycleType } });
  }, []);

  return (
    <div>
      <div>

        {Object.keys(rowData)?.length ? (
          <h3 className="operatorConfigHeading">
            Settlement Config
          </h3>
        ) : (
          <h3 className="operatorConfigHeading">
            Settlement Config
          </h3>
        )}
      </div>
      <div>
        <CheckedRadioGroup
          options={availableConfigs.map((config) => ({ label: config, value: config }))}
          defaultValue={settlementConfigData.settlementCycle}
          onChangeHandler={onChangeHandler}
          name="settlementCycle"
        />
      </div>

      <div className="mr-tp-10">
        <Button
          className="submitBtnContainer"
          variant="outlined"
          onClick={handleSave}
          buttonText="Save"
          disabled={
            !settlementConfigData.settlementCycle
          }
        />
      </div>
    </div>

  );
}
export default OperatorConfigModal;
